export const COMPUMATIC_PUNCH_TYPE_OPTIONS = [
  { value: 'clockIn', label: 'Clock in' },
  { value: 'clockOut', label: 'Clock out' },
  { value: 'breakOut', label: 'Break start' },
  { value: 'breakIn', label: 'Break end' },
] as const

const PUNCH_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  COMPUMATIC_PUNCH_TYPE_OPTIONS.map((option) => [option.value, option.label])
)

export function formatCompumaticPunchType(punchType: string) {
  return PUNCH_TYPE_LABELS[punchType] ?? punchType
}

export function isKnownCompumaticPunchType(
  punchType: string
): punchType is (typeof COMPUMATIC_PUNCH_TYPE_OPTIONS)[number]['value'] {
  return COMPUMATIC_PUNCH_TYPE_OPTIONS.some(
    (option) => option.value === punchType
  )
}

export function formatCompumaticPunchStatus(status: string) {
  return status
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}
